// TeamsTab.js
// Displays the provider teams table and delegates create/edit to TeamModal.

import React, { useState } from 'react';
import api from '../../services/api';
import Button from '../../components/Button';
import { styles } from './settingsShared';
import TeamModal from './TeamModal';

export default function TeamsTab({ teams, users, onRefresh }) {
  const [modalTeam, setModalTeam] = useState(null);

  const providers = users.filter(u => u.role === 'provider');

  const openModal = (team) => setModalTeam(team);
  const closeModal = () => { setModalTeam(null); onRefresh(); };
  const openAdd = () => setModalTeam({ id: null, name: '', lead_provider_id: '', members: [] });

  const toggleActive = async (team) => {
    try {
      await api.patch(`/provider-teams/${team.id}`, { is_active: !team.is_active });
      onRefresh();
    } catch {}
  };

  const handleDelete = async (team) => {
    if (!window.confirm(`Delete "${team.name}"? This cannot be undone.`)) return;
    try {
      await api.delete(`/provider-teams/${team.id}`);
      onRefresh();
    } catch {}
  };

  return (
    <div>
      <div style={styles.tabHeader}>
        <h2 style={styles.sectionTitle}>Provider Teams</h2>
        <Button onClick={openAdd}>+ Add Team</Button>
      </div>

      <table style={styles.table}>
        <thead>
          <tr>
            {['Team Name', 'Lead Provider', 'Members', 'Status', 'Actions'].map(h => (
              <th key={h} style={styles.th}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {teams.length === 0 && (
            <tr><td colSpan={5} style={styles.emptyRow}>No teams created yet.</td></tr>
          )}
          {teams.map(team => (
            <tr key={team.id} style={styles.tr}>
              <td style={styles.td}>{team.name}</td>
              <td style={styles.td}>
                {team.lead_provider.first_name} {team.lead_provider.last_name}
              </td>
              <td style={styles.td}>{team.members.length}</td>
              <td style={styles.td}>
                <span style={team.is_active ? styles.badgeActive : styles.badgeInactive}>
                  {team.is_active ? 'Active' : 'Inactive'}
                </span>
              </td>
              <td style={styles.td}>
                <div style={styles.actionGroup}>
                  <Button variant="neutral" size="sm" onClick={() => openModal(team)}>
                    Edit
                  </Button>
                  <Button
                    variant={team.is_active ? 'caution' : 'neutral'}
                    size="sm"
                    onClick={() => toggleActive(team)}
                  >
                    {team.is_active ? 'Deactivate' : 'Activate'}
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(team)}
                  >
                    Delete
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modalTeam !== null && (
        <TeamModal
          team={modalTeam}
          providers={providers}
          staffUsers={users.filter(
            u => u.role === 'clinical_staff' || u.role === 'non_clinical_staff'
          )}
          onClose={closeModal}
        />
      )}
    </div>
  );
}